var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"velocimetro-container"},[_c('div',{staticClass:"velocimetro"},[_c('div',{staticClass:"pointer",style:(_vm.posicao)})]),_c('div',{staticClass:"vlegend"},[_vm._v("5%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }